module.exports = __webpack_public_path__ + "img/lcc3.d74c74e2.png";